import React, { FC, useEffect, useState } from "react";
import Axios from "axios";
import {
  IMensagem,
  IFiltroCurso,
  IFiltroMateria,
  IFiltroSerie,
  IFiltroTurma,
} from "@deltasge/marauders-map";
import { LinearProgress } from "@mui/material";
import { CadastroMensagem } from "./CadastroMensagem";
import { IMensagemCategoria, utilMensagem as util } from "../utilMensagem";

export const Cadastro: FC<{
  idMensagem?: number;
  curso?: IFiltroCurso;
  serie?: IFiltroSerie;
  turma?: IFiltroTurma;
  materia?: IFiltroMateria;
  categoria: IMensagemCategoria;
  formId: string;
  handleClose: () => void;
}> = ({ idMensagem, formId, handleClose, categoria }) => {
  const CancelToken = Axios.CancelToken;
  const source = CancelToken.source();

  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState<IMensagem | undefined>();

  useEffect(() => {
    const getMensagem = async (id: number) => {
      setLoading(true);
      const msg = await util.getMensagem({
        idMensagem: id,
        cancelToken: source.token,
      });
      if (msg) {
        setMensagem(msg);
      }
      setLoading(false);
    };
    if (idMensagem) {
      getMensagem(idMensagem);
    }

    return () => source.cancel();
  }, [idMensagem]);

  return loading ? (
    <LinearProgress />
  ) : (
    <CadastroMensagem
      mensagem={mensagem}
      formId={formId}
      handleClose={handleClose}
      categoria={categoria}
    />
  );
};
